// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__MEpnh","FooterLinks":"Footer_FooterLinks__AP7Uz"};